import { render, staticRenderFns } from "./waterDt.vue?vue&type=template&id=221afece&scoped=true&"
import script from "./waterDt.vue?vue&type=script&lang=js&"
export * from "./waterDt.vue?vue&type=script&lang=js&"
import style0 from "./waterDt.vue?vue&type=style&index=0&lang=css&"
import style1 from "./waterDt.vue?vue&type=style&index=1&id=221afece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221afece",
  null
  
)

export default component.exports